import React, { useContext, useEffect, useState } from "react";
import { DarshanBook_TempleList } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import { Link, useNavigate } from "react-router-dom";
import { PoojaAtTemple } from "../../ApiServices/Pooja At Temple/PoojaTempleApi";
import { Tooltip } from "@mui/material";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import Breadcrumbs from "../Breadcrumb";

const PoojaAtTempleList = () => {
  const [darshanBookingList, setDarshanBookingList] = useState([]);
  const navigate = useNavigate();
  const { setLoader, loader } = useContext(LoaderContext);
  useEffect(() => {
    DarshanBookingTempleListData();
  }, []);
  const [searchKeyWord, setSearchKeyWord] = useState("");

  const [searchBtnClick, setSearchClicked] = useState(false);

  useEffect(() => {
    if (searchBtnClick) {
      DarshanBookingTempleListData();
      setSearchClicked(false);
    }
  }, [searchBtnClick]);

  const DarshanBookingTempleListData = async () => {
    setLoader(true);
    try {
      const userID = localStorage.getItem("userID") || "";

      const params = {
        START: 0,
        END: 10,
        WORD: searchKeyWord,
        LATITUDE: "",
        LONGITUDE: "",
      };

      const response = await PoojaAtTemple(params, userID);

      if (
        response?.ResponseCode === "0" &&
        response?.ResponseMessage === "list"
      ) {
        setLoader(false);
        setDarshanBookingList(response.DATA);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching temple list:", error.message);
    }
  };

  const handleNavigation = (temple) => {
    navigate(`/puja-at-temple/${temple.PoojaAtTempleSlug}`, {
      state: { temple },
    });
  };
  return (
    <div
      className="container mt-4 mb-3"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div style={{ padding: "8px" }}>
        <Breadcrumbs />
      </div>
      <div className="row mb-3">
        <div className="col-md-6 mx-auto">
          <div
            className="search-box"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "1",
              maxWidth: "100%",
              marginRight: "10px",
              gap: "10px",
            }}
          >
            <input
              type="text"
              className=" custom-search-input"
              placeholder="Search"
              value={searchKeyWord}
              onChange={(e) => setSearchKeyWord(e.target.value)}
            />
            <button
              className="input-group-text text-white"
              style={{ backgroundColor: "#a52444", padding: "8px 15px" }}
              onClick={() => {
                setSearchClicked(true);
              }}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className="row" style={{ justifyContent: "left" }}>
        {darshanBookingList?.length !== 0 &&
          darshanBookingList.filter(
            (temple) =>
              !searchKeyWord ||
              temple?.PAT_NAME?.toLowerCase().includes(
                searchKeyWord.toLowerCase()
              )
          ).length > 0 ? (
          darshanBookingList
            .filter(
              (temple) =>
                !searchKeyWord ||
                temple?.PAT_NAME?.toLowerCase().includes(
                  searchKeyWord.toLowerCase()
                )
            )
            .map((temple) => (
              <div
                key={temple.PAT_ID}
                className="col-lg-3 col-md-6 col-sm-6 product-item-one mb-3"
              >
                <div
                  className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNavigation(temple)}
                >
                  <div className="product-image text-center position-relative">
                    <img
                      src={temple.PAT_IMAGE || Batuk}
                      alt={temple.PAT_IMAGE}
                      className="card-img-top"
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                  </div>

                  <div
                    className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                    style={{ margin: "0" }}
                  >
                    <h6
                      className="fw-bold text-truncate"
                      style={{
                        fontSize: "18px",
                        color: "#8f3246",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      {temple.PAT_NAME}
                    </h6>
                    <div className="prod-details d-flex align-items-center flex-column">
                      <p className="mb-1">
                        📍 Location :
                        {temple.PAT_ADDRESS?.length > 20 ? (
                          <Tooltip title={temple.PAT_ADDRESS}>
                            {`${temple.PAT_ADDRESS.substring(0, 20)}...`}
                          </Tooltip>
                        ) : (
                          <strong> {temple.PAT_ADDRESS}</strong>
                        )}
                      </p>
                      <p className="mb-0">
                        Darshan Price : <strong> ₹{temple.PAT_PRICE}</strong>
                      </p>
                      <Link
                        to={`/temple/${temple.TempleSlug}`}
                        style={{
                          color: "#a52444",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                        }}
                      >
                        View Details <i className="icon-right-arrow"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
        ) : !loader ? (
          <div className="d-flex flex-column align-items-center justify-content-center text-center w-100 mt-4">
            <img
              src={Batuk}
              alt="Empty Cart"
              className="img-fluid mb-3"
              style={{ maxWidth: "200px" }}
            />
            <h5 className="fw-bold">No services available for this category</h5>
            <p className="text-muted">Please explore our other categories.</p>
          </div>
        ) : (
          ""
        )}
      </div>

      <style>
        {`
        .temple-header {
          background: linear-gradient(45deg, #ff6b6b, #57a0d1);
        //   border-radius: 8px;
        
          box-shadow: 0px 4px 12px rgba(255, 99, 99, 0.6);
          transition: transform 0.3s ease-in-out;
        //   width:
        }

        .temple-header:hover {
          transform: scale(1.02);
        }

        .temple-card {
          border-radius: 10px;
          overflow: hidden;
          border: none;
          box-shadow: 0px 4px 10px rgba(255, 0, 0, 0.5);
          transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
        }

        .temple-card:hover {
          transform: translateY(-5px);
        //   box-shadow: 0px 8px 16px rgba(255, 0, 0, 0.8);
        }

        .card-img-top {
          height: 200px;
          object-fit: cover;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      `}
      </style>
    </div>
  );
};

export default PoojaAtTempleList;
